<template>
  <div>
    <label class="form__label primary--text" :for="idElement" v-if="labelText">
      {{ labelText }}
      <v-tooltip
        bottom
        v-if="iconInformation"
        content-class="tooltip-label-form"
      >
        <template v-slot:activator="{ on }">
          <v-icon color="secondary" size="10" v-on="on">
            fa-info-circle
          </v-icon>
        </template>
        <v-row>
          <v-col cols="12" class="px-4 py-3">
            <p class="white--text tooltip-label-text mb-0">
              {{ textInformation }}
            </p>
          </v-col>
        </v-row>
      </v-tooltip>
    </label>
    <v-autocomplete
      v-on="$listeners"
      v-bind="defaultConfigs"
      :id="idElement"
      :data-cy="cypressId"
      @input="onInput"
      :class="hasLabelText"
    >
      <template v-slot:item="{ item }" v-if="templateInsured || templateTaker">
        {{ showTemplate(item) }}
      </template>
    </v-autocomplete>
  </div>
</template>
<script>
const defaultProp = {
  outlined: true,
  dense: true,
  "background-color": "white"
};
import _ from "lodash";
export default {
  model: {
    event: "update"
  },
  computed: {
    defaultConfigs() {
      return {
        ...this.$attrs,
        ...this.$props,
        ...defaultProp
      };
    },
    hasLabelText() {
      return this.labelText ? "mt-2" : "";
    }
  },
  methods: {
    onInput(value) {
      if (this.upperCase) {
        this.$emit("update", _.isString(value) ? value.toUpperCase() : value);
      } else {
        this.$emit("update", value);
      }
    },
    showTemplate(item) {
      return this.templateInsured
        ? `${item.nome} - ${item.numero_documento}`
        : `${item.nome_fantasia} - ${item.cnpj}`;
    }
  },
  props: {
    idElement: {
      type: String
    },
    labelText: {
      type: String,
      default: null
    },
    iconInformation: {
      type: Boolean,
      default: false
    },
    textInformation: {
      type: String
    },
    cypressId: {
      type: String,
      default: null
    },
    templateInsured: {
      type: Boolean,
      default: false
    },
    templateTaker: {
      type: Boolean,
      default: false
    },
    upperCase: {
      type: Boolean,
      default: true
    }
  }
};
</script>
<style lang="sass"></style>
